import { createClient } from '@supabase/supabase-js'
import { SUPABASE_CONFIG } from '../config/api.js'

// Create Supabase client
export const supabase = createClient(
  SUPABASE_CONFIG.url,
  SUPABASE_CONFIG.anonKey,
  {
    auth: SUPABASE_CONFIG.auth
  }
)

export default supabase